import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { SUBSCRIPTION_COLLECTION } from '@/gql/queries';
import { SubscriptionListFilterInput } from '@/generated/types';
import { FilterTagOption } from './types';

export interface UseDeviceOptionsReturn {
  deviceOptions: FilterTagOption[];
  areDeviceOptionsLoading: boolean;
}
type UseDeviceOptions = (args: {
  filter: SubscriptionListFilterInput;
  first: number;
  searchTerm: string;
  isBusinessUser?: boolean;
}) => UseDeviceOptionsReturn;

export const useDeviceOptions: UseDeviceOptions = ({
  filter,
  first,
  searchTerm,
  isBusinessUser,
}) => {
  const variables = {
    searchTerm,
    first,
    filter,
  };

  const { data, loading: areDeviceOptionsLoading } = useQuery(SUBSCRIPTION_COLLECTION, {
    variables,
    skip: isBusinessUser,
    fetchPolicy: 'network-only',
    onError: () => {
      throw Error('subscriptionCollection Error');
    },
  });

  const deviceOptions = useMemo(() => {
    const subscriptionCollection = data?.subscriptionCollection?.nodes ?? [];
    const sortedSubscription = [...subscriptionCollection].sort(
      (a, b) => new Date(b.product.createdAt).getTime() - new Date(a.product.createdAt).getTime()
    );

    // To filter out duplicate name
    const filteredSubscription = sortedSubscription.filter(
      (item, index, self) => index === self.findIndex((s) => s.name === item.name)
    );

    return filteredSubscription.map((subscription) => ({
      label: subscription.name,
      value: subscription.id,
    }));
  }, [data]);

  return {
    deviceOptions,
    areDeviceOptionsLoading,
  };
};
